import React, { useMemo } from 'react';
import { View } from 'react-native';

import styles from './isc-player-viewer.style';
import { useLessonContext } from '../../../hooks/lesson-player.context';
import { useActivityContext } from '../../../hooks/use-activity.context';
import { LessonActivitySelector } from '../../lesson-activity-selector/lesson-activity-selector.component';
import { LessonIndex } from '../../lesson-index/lesson-index';
import { ProgressBar } from '../../progress-bar/progress-bar';
import { ProgressBarHeader } from '../../progress-bar-header/progress-bar-header';
import { SlideIndicator } from '../../slide-indicator/slide-indicator.component';

export function ISCPlayerViewer({ originalSlides }) {
  const { indexVisible, hideIndex } = useLessonContext();

  const {
    totalSlides,
    currentSteps,
    currentIndex,
    currentActivity,
    totalActivitiesCompleted,
    currentTotalStepsCompleted,
    completeCurrentActivity,
    goNext,
    completions,
    goToActivityWithIndex,
  } = useActivityContext();

  const completionsWithoutFinishActivity = useMemo(
    () => completions.slice(0, -1),
    [completions]
  );

  const isLastSlide = currentIndex >= totalSlides;
  const actionText = !isLastSlide ? 'Next' : 'Finish';
  const stepsAmount = currentSteps.length || 1;
  const currentProgress = (currentTotalStepsCompleted / stepsAmount) * 100;

  const changeSlide = (index) => {
    hideIndex();
    goToActivityWithIndex(index);
  };

  return (
    <>
      <ProgressBarHeader style={styles.progressHeader}>
        <ProgressBar
          containerStyle={styles.progressBar}
          completions={completionsWithoutFinishActivity}
          currentIndex={currentIndex}
          currentProgress={currentProgress}
          isIndicatorVisible={!isLastSlide}
        />
        <SlideIndicator
          current={Math.min(totalActivitiesCompleted, totalSlides)}
          total={totalSlides}
        />
      </ProgressBarHeader>
      <View style={styles.activityView}>
        <LessonActivitySelector
          activity={currentActivity}
          completionButtonText={actionText}
          completeActivity={completeCurrentActivity}
          goNext={goNext}
          isLast={isLastSlide}
          isComplete={completions[currentIndex]}
          updateStepProgress={() => {}}
        />
        <LessonIndex
          slideNumber={currentIndex}
          completionList={completions}
          slides={originalSlides}
          changeSlide={(i) => changeSlide(i)}
          isVisible={indexVisible}
        />
      </View>
    </>
  );
}
